import { render, staticRenderFns } from "./AnnotationMarker.vue?vue&type=template&id=2bf812e8&scoped=true&"
import script from "./AnnotationMarker.vue?vue&type=script&lang=js&"
export * from "./AnnotationMarker.vue?vue&type=script&lang=js&"
import style0 from "./AnnotationMarker.vue?vue&type=style&index=0&id=2bf812e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf812e8",
  null
  
)

export default component.exports